import Api from "./Api";

export default {
  getWebsiteSettings: async() => Api().get("settings")
};
